//src/services/ai.ts
import { api } from "@/lib/apiClient";
import type { AiHistoryPage } from "@/types/ai";

export async function listAiHistory(params?: {
  page?: number;
  per_page?: number;
  feature?: string;
  transaction_type?: string;
  start_date?: string;
  end_date?: string;
}) {
  return api.get<AiHistoryPage>("/ai/history", {
    params: {
      page: params?.page || 1,
      per_page: params?.per_page || 20,
      feature: params?.feature || undefined,
      transaction_type: params?.transaction_type || undefined,
      start_date: params?.start_date || undefined,
      end_date: params?.end_date || undefined,
    },
  });
}
